export default __webpack_public_path__ + "static/lato-v17-latin-regular-319df0f5492062b546b0de9dcb568cb9.woff";